import { firestoreTimestamp } from "@/firebaseConfig";
import { getSettingById } from "@/collections/settings";

const NO_QR = "NO QR";
const alphanumeric =
  "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

const redsysErrors = {
  SIS0093: "Tarjeta denegada",
  SIS0499: "Error obteniendo claves del comercio en Android/Apple Pay",
  SIS0502: "Error al validar Id Oper",
  "0129": "Código de seguridad (CVV2/CVC2) incorrecto",
  "0190": "Denegación del emisor sin especificar motivo"
};

export default {
  data() {
    return {
      projectName: process.env.VUE_APP_PROJECT_NAME,
      projectUrl: process.env.VUE_APP_BASE_URL,
      settings: null,
      fallbackImage: `${process.env.VUE_APP_BASE_URL}/img/svg/image-solid.svg`,
      loadingGlobal: false,
      temporarilyDisable: false
    };
  },
  computed: {
    isActiveSoloCarta() {
      return this.settings ? this.settings.isActiveSoloCarta : false;
    },
    isActiveTranslator() {
      return this.settings && this.settings.isActiveTranslator
        ? this.settings.isActiveTranslator
        : false;
    },
    isHomeVersionDefault() {
      return process.env.VUE_APP_HOME_VERSION === "default";
    },
    isHomeVersionPremium() {
      return process.env.VUE_APP_HOME_VERSION === "premium";
    },
    isHomeVersionBar() {
      return process.env.VUE_APP_HOME_VERSION === "bar";
    },
    favicon() {
      if (!this.settings) {
        this.getSettings().then();
        return "";
      }
      return this.settings && this.settings.icons
        ? this.settings.icons.favicon
        : "";
    },
    companyName() {
      if (!this.settings) {
        this.getSettings().then();
        return "";
      }
      return this.settings.company ? this.settings.company.name : "";
    },
    barCompanyNavbarLogo() {
      if (!this.settings) {
        this.getSettings().then();
        return "";
      }
      return this.settings && this.settings.icons
        ? this.settings.icons.bar_logo
        : "";
    },
    companyShortName() {
      if (!this.settings) {
        this.getSettings().then();
        return "";
      }
      return this.settings.company ? this.settings.company.shortName : "";
    },
    companyAddress() {
      if (!this.settings) {
        this.getSettings().then();
        return "";
      }
      return this.settings.company ? this.settings.company.address : "";
    },
    companyNameLegal() {
      if (!this.settings) {
        this.getSettings().then();
        return "";
      }
      return this.settings.company ? this.settings.company.company : "";
    },
    companyNif() {
      if (!this.settings) {
        this.getSettings().then();
        return "";
      }
      return this.settings.company ? this.settings.company.nif : "";
    },
    companyWeb() {
      if (!this.settings) {
        this.getSettings().then();
        return "";
      }
      return this.settings.company ? this.settings.company.web : "";
    },
    companyEmail() {
      if (!this.settings) {
        this.getSettings().then();
        return "";
      }
      return this.settings.company ? this.settings.company.email : "";
    },
    companyInvoiceEmail() {
      if (!this.settings) {
        this.getSettings().then();
        return "";
      }

      if (!this.settings.company) {
        return "";
      }
      return this.settings.company.invoice_email
        ? this.settings.company.invoice_email
        : this.settings.company.email;
    },
    companyRegisterData() {
      if (!this.settings) {
        this.getSettings().then();
        return "";
      }
      return this.settings.company ? this.settings.company.registerData : "";
    },
    logoWidthTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.logoWidth
        ? this.settings.themes.logoWidth + "px"
        : "126px";
    },
    logoHeightTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.logoHeight
        ? this.settings.themes.logoHeight + "px"
        : "0px";
    },
    buttonBorderRadiusTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.buttonBorderRadius
        ? this.settings.themes.buttonBorderRadius + "px"
        : "50px";
    },
    cartBackgroudColorTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.cartBackgroudColor
        ? this.settings.themes.cartBackgroudColor
        : "#d4c9a9";
    },
    cartBorderTopColorTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.cartBorderTopColor
        ? this.settings.themes.cartBorderTopColor
        : "#000";
    },
    pageTitleTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.pageTitle
        ? this.settings.themes.pageTitle
        : "#000";
    },
    tableHeaderTextTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.tableHeaderText
        ? this.settings.themes.tableHeaderText
        : "#000";
    },
    tableValuesTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.tableValues
        ? this.settings.themes.tableValues
        : "#000";
    },
    formLabelTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.formLabel
        ? `${this.settings.themes.formLabel}`
        : "#000";
    },
    categoryTagBackgroundTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.categoryTagBackground
        ? this.settings.themes.categoryTagBackground
        : "#1976d2";
    },
    subCategoryTagBackgroundTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.subCategoryTagBackground
        ? this.settings.themes.subCategoryTagBackground
        : "#82b1ff";
    },
    dessertTagBackgroundTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.dessertTagBackground
        ? this.settings.themes.dessertTagBackground
        : "#ba87a7";
    },
    drinksTagBackgroundTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.drinksTagBackground
        ? this.settings.themes.drinksTagBackground
        : "#424242";
    },
    foodTagBackgroundTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.foodTagBackground
        ? this.settings.themes.foodTagBackground
        : "#1976d2";
    },
    priceTagBackgroundTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.priceTagBackground
        ? this.settings.themes.priceTagBackground
        : "#424242";
    },
    sectionTitleColorTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.sectionTitleColor
        ? this.settings.themes.sectionTitleColor
        : "#000";
    },
    colorsFoodPrimary() {
      return this.settings &&
        this.settings.colors &&
        this.settings.colors.comida
        ? this.settings.colors.comida.primaryColor
        : "#1976d2";
    },
    colorsFoodSecondary() {
      return this.settings &&
        this.settings.colors &&
        this.settings.colors.comida
        ? this.settings.colors.comida.secondaryColor
        : "#82b1ff";
    },
    colorsDrinksPrimary() {
      return this.settings &&
        this.settings.colors &&
        this.settings.colors.bebida
        ? this.settings.colors.bebida.primaryColor
        : "#1976d2";
    },
    colorsDrinksSecondary() {
      return this.settings &&
        this.settings.colors &&
        this.settings.colors.bebida
        ? this.settings.colors.bebida.secondaryColor
        : "#82b1ff";
    },
    colorsDessertPrimary() {
      return this.settings &&
        this.settings.colors &&
        this.settings.colors.postre
        ? this.settings.colors.postre.primaryColor
        : "#1976d2";
    },
    colorsDessertSecondary() {
      return this.settings &&
        this.settings.colors &&
        this.settings.colors.postre
        ? this.settings.colors.postre.secondaryColor
        : "#ba87a7";
    },
    colorsGeneralPrimary() {
      return this.settings &&
        this.settings.colors &&
        this.settings.colors.general
        ? this.settings.colors.general.primaryColor
        : "#000";
    },
    colorsGeneralSecondary() {
      return this.settings &&
        this.settings.colors &&
        this.settings.colors.general
        ? this.settings.colors.general.secondaryColor
        : "#fff";
    },
    adminNavigationBackTheme() {
      return [
        { color: this.colorsGeneralPrimary },
        { border: `4px solid ${this.colorsGeneralPrimary}` }
      ];
    },
    adminResetFiltersTheme() {
      return [
        { color: this.colorsGeneralPrimary },
        { border: `4px solid ${this.colorsGeneralPrimary}` }
      ];
    },
    adminSubmitTheme() {
      return [
        { color: this.colorsGeneralPrimary },
        { border: `3px solid ${this.colorsGeneralPrimary}` }
      ];
    },
    listItemNameColorTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.listItemNameColor &&
        this.settings.themes.listItemNameColor
        ? this.settings.themes.listItemNameColor
        : "#0c0c0c";
    },
    listItemPriceColorTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.listItemPriceColor &&
        this.settings.themes.listItemPriceColor
        ? this.settings.themes.listItemPriceColor
        : "#000";
    },
    listItemDescriptionColorTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.listItemDescriptionColor &&
        this.settings.themes.listItemDescriptionColor
        ? this.settings.themes.listItemDescriptionColor
        : "rgba(0, 0, 0, 0.87)";
    },
    oddColorTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.oddColor &&
        this.settings.themes.oddColor
        ? this.settings.themes.oddColor
        : "#000";
    },
    titleLetterColorTheme() {
      return this.settings &&
        this.settings.themes &&
        this.settings.themes.titleLetterColor
        ? this.settings.themes.titleLetterColor
        : "#000";
    },
    isOnlyMenu() {
      return this.$router.currentRoute.name === "carta";
    }
  },
  async mounted() {
    this.getSettings();
  },
  methods: {
    iOS() {
      return (
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod"
        ].includes(navigator.platform) ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      );
    },
    async getSettings() {
      this.loadingGlobal = true;
      try {
        this.settings = await getSettingById("settings");

        const favicon = document.getElementById("favicon");
        favicon.href = this.favicon;
        setTimeout(() => {
          this.loadingGlobal = false;
        }, 1500);
      } catch (error) {
        this.setlogError(
          "get_setting",
          "Error obteniendo settings",
          error.stack,
          this.$options.name
        );
        setTimeout(() => {
          this.loadingGlobal = false;
        }, 1500);
      }
    },
    arrayGroupBy(array, key) {
      const result = {};
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });

      return result;
    },
    tableQRLabel(queryQR) {
      let qr = queryQR !== undefined ? queryQR : NO_QR;
      if (qr.length === 2) {
        let substring1 = qr.substring(0, 1);
        let substring2 = qr.substring(1, 2);

        if (isNaN(parseInt(substring1)) && !isNaN(parseInt(substring2))) {
          return `${substring1}0${substring2}`.toUpperCase();
        }
      }

      return qr.toUpperCase();
    },
    disableProducts(schedule) {
      const currentDate = this.buildCurrentDateToHandleSchedule();
      const time = schedule.find(
        time => time.id === currentDate.getDay().toString()
      );

      return !this.scheduleAvailableDate(currentDate, time);
    },
    disableMenu(schedule) {
      const currentDate = this.buildCurrentDateToHandleSchedule();

      const time = schedule[currentDate.getDay()];
      return !this.scheduleAvailableDate(currentDate, time);
    },
    scheduleAvailableDate(currentDate, time) {
      if (
        time === undefined ||
        (time.first &&
          time.first.init === time.first.fin &&
          time.second &&
          time.second.init === time.second.fin)
      ) {
        return false;
      }

      let hour = this.buildCurrentHourToHandleSchedule(currentDate);
      time =
        hour <= time.first.fin || time.second.init === time.second.fin
          ? time.first
          : time.second;

      if (time.fin > time.init) {
        let timeFin = time.fin < 1 ? time.fin + 24 : time.fin;
        return hour >= time.init && hour < timeFin;
      }

      if (hour < time.fin) {
        return true;
      }

      return hour >= time.init && hour > time.fin;
    },
    buildCurrentDateToHandleSchedule() {
      let currentDate = firestoreTimestamp.fromDate(new Date()).toDate();
      let hour = this.buildCurrentHourToHandleSchedule(currentDate);
      if (hour <= 6) {
        currentDate.setDate(currentDate.getDate() - 1);
      }
      return currentDate;
    },
    buildCurrentHourToHandleSchedule(currentDate) {
      // getMinutes: An integer between 0 and 59
      const minutes = currentDate.getMinutes();
      // getHours: An integer between 0 and 23
      return currentDate.getHours() + minutes / 100;
    },
    dynamicsort(property, order) {
      let sort_order = order === "desc" ? -1 : 1;
      return function(a, b) {
        // a should come before b in the sorted order
        if (a[property] < b[property]) {
          return -1 * sort_order;
          // a should come after b in the sorted order
        } else if (a[property] > b[property]) {
          return sort_order;
          // a and b are the same
        } else {
          return 0;
        }
      };
    },
    randomId() {
      // Random 4 digit number between 0 and 9999
      const num = this.randomInt(10000);
      const numStr = num.toString().padStart(4, "0");
      // Random 8 letter alphanumeric sequence
      const alphanum = new Array(8);

      for (let idx = 0; idx < 8; idx++) {
        alphanum[idx] = alphanumeric[this.randomInt(alphanumeric.length)];
      }

      const alphanumStr = alphanum.join("");
      return `${numStr}${alphanumStr}`;
    },
    randomInt(top) {
      return Math.floor(Math.random() * Math.floor(top));
    },
    showImageOrFallbackImage(image) {
      return image ? image : this.fallbackImage;
    },

    getRedsysErrorMessage(errorCode) {
      if (errorCode && redsysErrors[errorCode]) {
        return redsysErrors[errorCode];
      }
      return "Something went wrong in redsys- errorcode: " + errorCode;
    }
  },
  // is used in STORE
  tableFromLocalStorage() {
    let tableQR = window.localStorage.getItem("tableQR");
    return tableQR ? tableQR : NO_QR;
  },
  adminTableFromLocalStorage() {
    let adminTableQR = window.localStorage.getItem("adminTableQR");
    return adminTableQR ? adminTableQR : NO_QR;
  },
  getRedsysErrorMessage(errorCode) {
    if (errorCode && redsysErrors[errorCode]) {
      return redsysErrors[errorCode];
    }
    return "Something went wrong in redsys- errorcode: " + errorCode;
  },
  areStripeVariablesEmpty() {
    return (
      process.env.VUE_APP_STRIPE_PUBLIC_KEY === "" ||
      process.env.VUE_APP_STRIPE_PUBLIC_KEY === "need_to_change" ||
      process.env.VUE_APP_STRIPE_PRIVATE_KEY === "" ||
      process.env.VUE_APP_STRIPE_PRIVATE_KEY === "need_to_change"
    );
  }
};
